module.exports = __webpack_public_path__ + "bd8d064256ebcd9d316e14587b2da5e1.pdf";